import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_VIEW_AVATAR(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.BOTVIEW, name: name, contents: [] };

  cat.contents = [
    BH.label("Bot-Ansichten -> " + name),
    BH.withNested(
      BH.styling("AVATAR_setBGImg", "Hintergrund: {{source[@check=URL,IMAGE]}}", "await RAGAI.VIDEO_AVATAR.setBackgroundImage({{source}});"),
      [{
        forValue: 'source',
        isShadow: false,
        targetBlockType: 'BLOCK_STACK_IMAGE'
      }]),
    BH.styling("AVATAR_unsetBGImg", "Avatar Hintergrund entfernen", "await RAGAI.VIDEO_AVATAR.unsetImage();"),
    BH.styling("AVATAR_stop", "Avatar-Denken und -Sprechen abbrechen", "await RAGAI.VIDEO_AVATAR.stop();"),
    BH.withNested(
      BH.styling("AVATAR_addFooterButton", "Footer-Button hinzufügen: {{text}}\n bei Klick: {{aktion:statement[@check=ACTION,OVERLAY]}}", "RAGAI.VIDEO_AVATAR.addFooterButton({text: {{text}}, onClick: async function(){ {{aktion}} }});"),
      [{ forValue: "text", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Button Name" } }]
    ),
    BH.styling("AVATAR_clearFooterButtons", "Alle Footer-Buttons entfernen", "RAGAI.VIDEO_AVATAR.clearFooterButtons();"),
    BH.withNested(
      BH.ragAi("AVATAR_doNotInterrupt",
        `⏭️ Automatisches Stummen des Mikrofons, um den Avatar nicht zu unterbrechen.
        Hinweistext, wenn der Avatar...
        ...zuhört: {{botListening}}
        ...denkt: {{botThinking}}
        ...spricht: {{botSpeaking}}`,

        `RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"] = RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"] || [];
        RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AVATAR.SPEECH.thinking", function() {
          RAGAI.AUDIO.muteMic();
          RAGAI.VIDEO_AVATAR.setText({{botThinking}});
        }));
        RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AVATAR.SPEECH.play", function() {
          RAGAI.AUDIO.muteMic();
          RAGAI.VIDEO_AVATAR.setText({{botSpeaking}});
        }));
        RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AVATAR.SPEECH.done", function() {
          RAGAI.AUDIO.unmuteMic();
          RAGAI.VIDEO_AVATAR.setText({{botListening}});
        }));`,
      ),
      [
        { forValue: "botListening", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Jetzt reden" } },
        { forValue: "botThinking", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Nachricht wird gesendet" } },
        { forValue: "botSpeaking", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Jetzt zuhören" } }
      ]
    ),
    BH.ragAi("AVATAR_doNotInterruptCancel",
      "🧹 Automatisches Stummschalten verwerfen",
      `RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"] = RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"] || [];
      for (const __id of RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"]) {
        RAGAI.EVENTS.off(__id);
      }
      RAGAI.VARIABLES["AVATAR_doNotInterrupt_ids"] = [];`,
    )
  ];




  return cat;

}
